var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 0H12C5.37258 0 0 5.37258 0 12V36C0 42.6274 5.37258 48 12 48H36C42.6274 48 48 42.6274 48 36V12C48 5.37258 42.6274 0 36 0Z",
    fill: "#ED4F9D",
    fillOpacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 33C28.9706 33 33 28.9706 33 24C33 19.0294 28.9706 15 24 15C19.0294 15 15 19.0294 15 24C15 28.9706 19.0294 33 24 33Z",
    stroke: "#ED4F9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8 20.9999C26.6188 20.6857 26.3557 20.4266 26.0386 20.2505C25.7215 20.0743 25.3625 19.9877 25 19.9999H23C22.4696 19.9999 21.9609 20.2106 21.5858 20.5857C21.2107 20.9608 21 21.4695 21 21.9999C21 22.5303 21.2107 23.039 21.5858 23.4141C21.9609 23.7892 22.4696 23.9999 23 23.9999H25C25.5304 23.9999 26.0391 24.2106 26.4142 24.5857C26.7893 24.9608 27 25.4695 27 25.9999C27 26.5303 26.7893 27.039 26.4142 27.4141C26.0391 27.7892 25.5304 27.9999 25 27.9999H23C22.6375 28.0121 22.2785 27.9255 21.9614 27.7494C21.6443 27.5732 21.3812 27.3141 21.2 26.9999",
    stroke: "#ED4F9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 28V30M24 18V20",
    stroke: "#ED4F9D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon3);
export default __webpack_public_path__ + "static/media/sales_icon3.57fe3273d080fd8bda0437cee9724daf.svg";
export { ForwardRef as ReactComponent };